<template>
    <div class="ets009" :style="dBHeight">
        <div class="inner">
            <div class="img"><img src="../../assets/img/stop.png" alt="일시적으로 서비스를 이용하실 수 없습니다."></div>
            <div class="tit">{{ $i18nUtil.trans("message.Error.001", "일시적으로 서비스를 이용하실 수 없습니다.") }}</div>
            <div class="txt" v-html="$i18nUtil.trans('message.Error.002', '<p>이용에 불편을 드려 죄송합니다.<br>사용자가 많거나 일시적인 시스템 오류로 인해 페이지를 불러올 수 없습니다.</p>잠시 후 다시 시도해주세요.')">
                <!-- <p>이용에 불편을 드려 죄송합니다.<br>사용자가 많거나 일시적인 시스템 오류로 인해 페이지를 불러올 수 없습니다.</p>
                잠시 후 다시 시도해주세요. -->
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            dBHeight: {
                'min-height': (window.innerHeight - 50 - 123) + 'px',
            },
        };
    },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/Error.vue